import { Bell, Moon, Sun, Search, Menu } from "lucide-react";
import { useTheme } from "@/lib/theme";
import { useAuth } from "@/lib/auth";

export default function Topbar({ title, subtitle, onMenu, actions }) {
  const { theme, toggle } = useTheme();
  const { user } = useAuth();

  return (
    <header className="sticky top-0 z-30 bg-background/85 backdrop-blur-md border-b border-border">
      <div className="flex items-center justify-between px-4 md:px-8 py-4">
        <div className="flex items-center gap-3 min-w-0">
          <button
            className="lg:hidden p-2 rounded-md hover:bg-muted"
            onClick={onMenu}
            data-testid="mobile-menu-btn"
          >
            <Menu className="size-5" />
          </button>
          <div className="min-w-0">
            <h1 className="font-display text-xl md:text-2xl font-semibold tracking-tight truncate" data-testid="page-title">{title}</h1>
            {subtitle && <p className="text-xs md:text-sm text-muted-foreground mt-0.5">{subtitle}</p>}
          </div>
        </div>

        <div className="flex items-center gap-2 md:gap-3">
          <div className="hidden md:flex items-center gap-2 px-3 py-2 rounded-lg bg-muted/60 border border-border min-w-[260px]">
            <Search className="size-4 text-muted-foreground" />
            <input
              placeholder="Search clients, jobs, invoices..."
              className="bg-transparent outline-none text-sm flex-1"
              data-testid="global-search"
            />
          </div>
          <button
            onClick={toggle}
            className="p-2 rounded-md hover:bg-muted border border-border"
            data-testid="theme-toggle"
            aria-label="Toggle theme"
          >
            {theme === "dark" ? <Sun className="size-4" /> : <Moon className="size-4" />}
          </button>
          <button className="p-2 rounded-md hover:bg-muted border border-border relative" data-testid="notifications-btn">
            <Bell className="size-4" />
            <span className="absolute top-1.5 right-1.5 size-1.5 rounded-full bg-primary" />
          </button>
          <div className="hidden sm:flex items-center gap-2 pl-2">
            <div className="size-8 rounded-full bg-primary text-primary-foreground flex items-center justify-center font-display font-semibold text-sm">
              {(user?.name || "S").slice(0, 1)}
            </div>
            <div className="leading-tight text-right">
              <div className="text-sm font-medium">{user?.name || "Admin"}</div>
              <div className="text-[11px] text-muted-foreground">Owner</div>
            </div>
          </div>
        </div>
      </div>
      {actions && <div className="px-4 md:px-8 pb-4 flex flex-wrap gap-2">{actions}</div>}
    </header>
  );
}
